export enum VoucherType {
  Percentage = 'percentage',
  Fixed = 'fixed',
}
